import { combineReducers } from 'redux';
import { assign } from 'lodash';

import {
    SET_SOCIAL_PROVIDER,
    SET_SOCIAL_DATA,
    SET_SOCIAL_LINKED_ACCOUNT,
    RE_REQUEST_PERMISSIONS,
} from '../actions/social';

const socialProvider = (state = '', { type, payload }) => {
    let nextState = state;

    if (type === SET_SOCIAL_PROVIDER) {
        nextState = payload;
    }

    return nextState;
};

const socialData = (
    state = { apple: {}, facebook: {}, google: {} },
    { type, payload },
) => {
    const nextState = state;

    if (type === SET_SOCIAL_DATA) {
        nextState[payload.socialProvider] = payload.socialData;
    }

    return nextState;
};

const socialLinkedAccount = (state = {}, { type, payload }) => {
    let nextState = state;

    if (type === SET_SOCIAL_LINKED_ACCOUNT) {
        nextState = {
            ...nextState,
            ...payload,
        };
    }
    return nextState;
};

const socialSSOSettings = (state = {}, { type, payload }) => {
    let nextState = state;

    if (type === RE_REQUEST_PERMISSIONS) {
        nextState = state;
        nextState.facebook = assign(
            { reRequestPermissions: payload },
            state.facebook,
        );
    }

    return nextState;
};

export default combineReducers({
    socialProvider,
    socialData,
    socialLinkedAccount,
    socialSSOSettings,
    skipSocialCalls: (state = false) => state,
});
